import { useLayoutEffect, useState } from 'react';

interface UseMeasuredWidthResult {
  containerRef: (element: HTMLElement | null) => void;
  width: number;
}

const useMeasuredWidth = (fallbackWidth = 0): UseMeasuredWidthResult => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [measuredWidth, setMeasuredWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    if (!container) {
      return;
    }

    const updateWidth = () => setMeasuredWidth(container.getBoundingClientRect().width);

    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(container);

    return () => observer.disconnect();
  }, [container]);

  return {
    containerRef: setContainer,
    width: measuredWidth ?? fallbackWidth,
  };
};

export default useMeasuredWidth;
